import React from "react";
import { Link } from "react-router-dom";
import { FaPhone, FaUser } from "react-icons/fa";
import { encodeWithSalt } from "../../../utils/encodeFunctions";
import { formatEpochTime } from "../../../utils/timeConvertors";
import "./ad-details.css";

interface AdDetailsProps {
  adDetails: any;
}

function AdDetails({ adDetails }: AdDetailsProps) {
  return (
    <div className="listing-details-card">

      {/* Price block */}
      <div className="listing-details-price-block">
        <div className="listing-details-price">
          Rs. {adDetails?.price?.toLocaleString()}
        </div>
        {adDetails?.negotiable && (
          <div className="listing-details-negotiable">Negotiable</div>
        )}
        <div className="listing-details-posted">
          Posted on{" "}
          <strong>{formatEpochTime(Number(adDetails?.time))}</strong>
        </div>
      </div>

      {/* Seller block */}
      <div className="listing-details-seller-block">
        <div className="listing-details-seller-label">Seller Information</div>

        <div className="listing-details-contact-row">
          <span className="listing-details-contact-label">
            <FaUser size={12} style={{ marginRight: 5 }} />
            Seller
          </span>
          <Link
            to={`/seller-profile/${encodeWithSalt(adDetails?.seller_profile?.id)}`}
            className="listing-details-seller-link listing-details-contact-value"
          >
            {adDetails?.seller_profile?.name}
          </Link>
        </div>

        <hr className="listing-details-divider" />

        <div className="listing-details-contact-row">
          <span className="listing-details-contact-label">Location</span>
          <span className="listing-details-contact-value" style={{ cursor: "default" }}>
            {adDetails?.location ?? "Colombo"}
          </span>
        </div>

        <hr className="listing-details-divider" />

        <div className="listing-details-contact-row">
          <span className="listing-details-contact-label">
            <FaPhone size={12} style={{ marginRight: 5 }} />
            Phone
          </span>
          <a
            href={`tel:${adDetails?.seller_profile?.mobile_number}`}
            className="listing-details-contact-value"
          >
            {adDetails?.seller_profile?.mobile_number}
          </a>
        </div>
      </div>

      {/* CTA */}
      <div className="listing-details-cta">
        <a
          href={`tel:${adDetails?.seller_profile?.mobile_number}`}
          className="btn btn-danger w-100 fw-bold"
        >
          <FaPhone size={13} style={{ marginRight: 6 }} />
          Call Seller
        </a>
      </div>
    </div>
  );
}

export default AdDetails;
